import { render, staticRenderFns } from "./TehniquePage.vue?vue&type=template&id=2c60c117&scoped=true&"
import script from "./TehniquePage.vue?vue&type=script&lang=js&"
export * from "./TehniquePage.vue?vue&type=script&lang=js&"
import style0 from "./TehniquePage.vue?vue&type=style&index=0&id=2c60c117&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60c117",
  null
  
)

export default component.exports